module.exports = __webpack_public_path__ + "static/saitotaq-bf29ae1b63ef782a74fb753ac65e33e2.jpg";